import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { FormattedMessage, IntlProvider } from "react-intl"

import ErrorBoundary from "../../ErrorBoundary"
import en from "../../translations/en.json"
import zh from "../../translations/zh.json"
import ja from "../../translations/ja.json"
import nl from "../../translations/nl.json"

function FormattedNav({ translationProps }) {
  return <FormattedMessage {...translationProps} description={"Navigation Option"} />
}

const NavOptionWrapper = ({ children }) => {
  const messages = { en, zh, ja, nl }
  const [locale, setLocale] = useState("en")

  useEffect(() => {
    if (window.lanzacofee.language) {
      setLocale(window.lanzacofee.language)
    }
  }, [window.lanzacofee.language])

  return (
    <IntlProvider locale={locale} messages={messages[locale]} defaultLocale={"en"}>
      {children}
    </IntlProvider>
  )
}

function getNav(translationProps) {
  const Wrapper = ({ children }) => {
    const [locale, setLocale] = useState()
    useEffect(() => {
      if (window.lanzacofee.language) {
        setLocale(window.lanzacofee.language)
      }
    }, [window.lanzacofee.language])
    return <ErrorBoundary>{children}</ErrorBoundary>
  }

  return (
    <Wrapper>
      <NavOptionWrapper>
        <FormattedNav translationProps={translationProps} />
      </NavOptionWrapper>
    </Wrapper>
  )
}

// Manually update each nav option to apply translation
const GenerateNavOptions = () => {
  const id_map = {
    // key: navigation <span> id, value: translation id
    "live-nav-text": { id: "navigation.liveRunOption" },
    "live-sys-nav-text": { id: "navigation.liveSystemOption" },
    "archive-nav-text": { id: "navigation.archivedRunOption" },
    "ferm-nav-text": { id: "navigation.fermManagementOption" },
    "source-reg-nav-text": { id: "navigation.source.registration" },
    "sample-nav-text": { id: "navigation.sampleManagementOption" },
    "ns-nav-text": { id: "navigation.nsManagementOption", defaultMessage: "Nutrient Solution Management" },
    "inventory-nav-text": { id: "navigation.inventory.management" },
    "data-transfer-nav-text": { id: "navigation.dataTransferOption" },
    "administration-nav-text": { id: "navigation.administrationOption" },
    "user-files-nav-text": { id: "navigation.userFilesOption", defaultMessage: "User Files" },
    "user-management-nav-text": { id: "navigation.userManagementOption" },
    "database-backup-nav-text": { id: "administration.database-backup" },
    "system-management-nav-text": { id: "administration.system-management" },
    "file-uploads-nav-text": { id: "administration.file-uploads" },
    "account-nav-text": { id: "navigation.accountOption" },
    "login-nav-text": { id: "navigation.loginOption" },
    "logout-nav-text": { id: "navigation.logoutOption" },
    "password-nav-text": { id: "navigation.passwordOption" },
  }

  Object.keys(id_map).forEach((id) => {
    const container = document.getElementById(id)
    if (container) {
      ReactDOM.render(getNav(id_map[id]), container)
    }
  })
}

export default GenerateNavOptions
